import { get, writable } from 'svelte/store';

export interface NamePromptRequest {
  title: string;
  label: string;
  defaultValue: string;
  resolve: (value: string | null) => void;
}

export const namePrompt = writable<NamePromptRequest | null>(null);

export function requestName(options: Omit<NamePromptRequest, 'resolve'>): Promise<string | null> {
  // Map clicks can happen quickly; close any superseded request cleanly.
  get(namePrompt)?.resolve(null);
  return new Promise((resolve) => namePrompt.set({ ...options, resolve }));
}

export function resolveNamePrompt(value: string | null): void {
  const request = get(namePrompt);
  if (!request) return;
  namePrompt.set(null);
  request.resolve(value);
}
